// Lit un flux SSE « data: {json} » (séparé par des lignes vides) et passe chaque événement à onEvent.
export const readSseEvents = async (reader, onEvent) => {
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    let boundary = buffer.indexOf('\n\n');

    while (boundary !== -1) {
      const chunk = buffer.slice(0, boundary).trim();
      buffer = buffer.slice(boundary + 2);
      if (chunk.startsWith('data:')) {
        const payload = chunk.replace(/^data:\s*/, '');
        if (payload !== '[DONE]') {
          try {
            onEvent(JSON.parse(payload));
          } catch (error) {
            console.warn('Échec du parsing SSE:', error);
          }
        }
      }
      boundary = buffer.indexOf('\n\n');
    }
  }
};
